import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IEditInvoice } from "@shared/interfaces";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { JwtService } from "./jwt.service";

@Injectable()
export class AdminInvoicesService {

  constructor(
    private http: HttpClient,
    private jwtService: JwtService
  ){
  }

  private get token() {
    return this.jwtService.getTocken() ?? '';
  }  

  get headers(): HttpHeaders {
    return new HttpHeaders({
      //Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiNTJhZmQ2YjdiZjRjNTEyZGMwMzU0ZmMxMWFmOGQ4N2ZmOWRhM2M0ODdkYWQ4YTE5MzUyYTk3YjFjZGRjZjQyYWZmMWM4ZWQwZmQ0MTNjZWMiLCJpYXQiOjE2NTExNDExODguMzI1ODY5LCJuYmYiOjE2NTExNDExODguMzI1ODcxLCJleHAiOjE2ODI2NzcxODguMzIwODIsInN1YiI6IjIiLCJzY29wZXMiOltdfQ.GlCtjQhjWrlnamUFVb68QFavn51IdH0iFCcuK3kT5UgGtjkPftRgvES_S-DCj76w7AhTWP6TQ7r1qKXwV_siuUbPktsctCbTPubayKy3LtiaT59jDg54py7sAjg6e9gws1w64BX6HgCJrvpkK97_fvsrdaeDVGteKR-jOTD7fjsoRfPeqTGDgNaM81JuDDjcQOHfiR3x7P0FJHSx4WB38F3mu-Edz6OwrlnLbAuCHUN1ueC1xjFvUAcTJ49rzJekXhnD-hPJeAOw89f18-MGAw4qPG_OZI7LuxvyO859h-HExWJ3quPZWzbdNWCgGran8JiLMty5jq5gO2LzrLidOwjtjjpCWmT-sTeV5ptKWLac1gaxS8lqDmCJs0khogX59muV2zZR0rEw0O_Ie5JWwuzGU-ofBAIPv0wIm-kGJAadeU6EPLHZN1QHZiVWorxav1LTgtVjmpMIi5GLnehvpLcxhrUaDblLcMmXRumfBQNs0RDyf8_MljOd4T1p3Eg1PKAuWyvOFKPsNAe1cRzJDuYJxIunsC38HWg-AL8iHFY99VM6MHPvySjUNPeK311loEykIuN3nhwVaOHrVtuhJoE432FD-wzNt802DjXPFJfxWTNXfPuZEoUA56S-2i8vKgjIh8PrXKjzG3J0xOkpTacbKyGYnGTxgWDCiznaCuU'
      Authorization: 'Bearer ' + this.token
    });
  }


  getDrafrs(page: number,search?:string): Observable<any> {
    let url = environment.apiUrl + `/operator/draftInvoices?count=5000&page=${page}${search?search:''}`;
    return this.http.get(url, {headers: this.headers});
  }

  sendDrafts(body:any){
    let url = environment.apiUrl + `/operator/invoices`;
    return this.http.post(url, body, {headers: this.headers, observe: 'response'});
  }
  
  deleteDraft(id:number){
    let url = environment.apiUrl + `/operator/draftInvoices/${id}`;
    return this.http.delete(url, {headers: this.headers, observe: 'response'});
  }


  getInvoices(page: number,search?:string): Observable<any> {
    let url = environment.apiUrl + `/operator/invoices?isArchive=false&count=20&page=${page}${search?search:''}`;
    return this.http.get(url, {headers: this.headers});
  }

  getPartnerInvoices(page: number,search?:string): Observable<any> {
    let url = environment.apiUrl + `/operator/shopDocs?isArchive=false&count=20&page=${page}${search?search:''}`;
    return this.http.get(url, {headers: this.headers});
  }

  getArchiveInvoices(page: number,search?:string): Observable<any> {
    let url = environment.apiUrl + `/operator/invoicesArchive?count=20&page=${page}${search?search:''}`;
    return this.http.get(url, {headers: this.headers});
  }

  getInvoicesWithBarcodes(search?:string): Observable<any> {
    //let url = environment.apiUrl + `/operator/invoices?count=99999&not_null_barcode=true${search?search:''}`;
    let url = environment.apiUrl + `/operator/invoices?count=99999${search?search:''}`;
    return this.http.get(url, {headers: this.headers});
  }

  sendProductFromInvoice(id:number): Observable<any> {
    let url = environment.apiUrl + `/operator/sendProductFromInvoice/${id}`;
    return this.http.post(url, {headers: this.headers, observe: 'response'});
  }

  setInvoicePaid(id:number): Observable<any> {
    let url = environment.apiUrl + `/operator/payedInvoice/${id}`;
    return this.http.post(url, {headers: this.headers, observe: 'response'});
  }

  getInvoicePdf(id:number): Observable<any> {
    const url = environment.apiUrl + `/operator/invoicePdf/${id}`;
    return this.http.get(url, {headers: this.headers, responseType: 'blob' as 'json'});
  }

  getPartnerInvoicePdf(id:number): Observable<any> {
    const url = environment.apiUrl + `/operator/shopDocs/${id}`;
    return this.http.get(url, {headers: this.headers, responseType: 'blob' as 'json'});
  }

  deletePartnerInvoice(id:number): Observable<any> {
    const url = environment.apiUrl + `/operator/shopDoc/${id}`;
    return this.http.delete(url, {headers: this.headers, observe: 'response'});
  }

  getManifests(body:any){
    let url = environment.apiUrl + `/operator/download-manifest`;
    return this.http.post(url, body, {headers: this.headers, responseType: 'blob' as 'json', observe: 'response'});
  }

  getLabels(body:any){
    let url = environment.apiUrl + `/operator/download-labels`;
    return this.http.post(url, body, {headers: this.headers, responseType: 'blob' as 'json', observe: 'response'});
  }

  revertInvoice(){
    let url = environment.apiUrl + `/revertInvoice/61`;
    return this.http.post(url, {}, {headers: this.headers});
  }

  revertDelivery(invoiceId: any){
    let url = environment.apiUrl + `/operator/revertDelivery/${invoiceId}`;
    return this.http.post(url, {headers: this.headers, observe: 'response'});
  }

  editInvoice(invoice_id: number, body: IEditInvoice) {
    const url = environment.apiUrl +`/operator/invoices/${invoice_id}`;
    return this.http.post(url, {
      invoice: body
    });
  }

  initiateShipment(body: any){
    let url = environment.apiUrl + `/ltpost/initiateShipment`;
    return this.http.post(url, body, {headers: this.headers, observe: 'response'});
  }

  downloadManifest(): Observable<any> {
    const url = environment.apiUrl + `/ltpost/downloadManifest`;
    return this.http.get(url, {headers: this.headers, responseType: 'blob' as 'json', observe: 'response'});
  }

  downloadSticker(): Observable<any> {
    const url = environment.apiUrl + `/ltpost/downloadSticker`;
    return this.http.get(url, {headers: this.headers, responseType: 'blob' as 'json', observe: 'response'});
  }

  getInvoicesProcess(): Observable<any> {
    const url = environment.apiUrl + `/operator/invoices_process`;
    return this.http.get(url, {headers: this.headers});
  }

  createDrafts(): Observable<any> {
    const url = `https://okplius-newtest.acruxcsdev.xyz/api/createDraft`;
    return this.http.get(url, {headers: this.headers});
  }

}